import { TermCourseServant } from '../../term_courses/servants/term_course_servant';
import { MultiSectionServant } from '../servants/multi_section_servant';
import { ISection } from '../../../interfaces/scheduler_interfaces';
import { ScheduledSectionServant } from '../servants/scheduled_section_servant';
import * as _4 from 'lodash4';

export class ScheduledSectionFilters {
  constructor(
    private ngScheduledSectionServant: ScheduledSectionServant,
    private ngMultiSectionServant: MultiSectionServant,
    private ngTermCourseServant: TermCourseServant
  ) {}

  getScheduledSections(sections: ISection[]) {
    return _4.filter(sections, (section: ISection) => ScheduledSectionServant.isSectionScheduled(section));
  }

  getScheduledMultiSections(sections: ISection[]) {
    return _4.sortBy(
      _4.filter(
        sections,
        (section: ISection) =>
          this.ngScheduledSectionServant.isSectionScheduledMultiSection(section) &&
          !this.ngMultiSectionServant.hasUnscheduledRequiredSiblingSections(section, sections)
      ),
      [(section: ISection) => section.course, (section: ISection) => _4.get(section, '_section_type.rank', 0)]
    );
  }

  getRegisteredSections(sections: ISection[]) {
    return _4.filter(sections, (section: ISection) =>
      this.ngScheduledSectionServant.isNonMultiSectionRegistered(section)
    );
  }

  getRegisteredMultiSections(sections: ISection[]) {
    return _4.sortBy(
      _4.filter(sections, (section: ISection) => this.ngScheduledSectionServant.isMultiSectionRegistered(section)),
      [(section: ISection) => section.course, (section: ISection) => _4.get(section, '_section_type.rank', 0)]
    );
  }

  getMultiSectionsWithSiblingUnscheduledSections(sections: ISection[]) {
    return _4.sortBy(
      _4.filter(
        sections,
        (section: ISection) =>
          this.ngMultiSectionServant.hasUnscheduledRequiredSiblingSections(section, sections) &&
          !this.ngScheduledSectionServant.isSectionWithdrawn(section) &&
          !this.ngMultiSectionServant.isRegisteredMultiSection(section) &&
          !ScheduledSectionServant.isSectionWaitListed(section)
      ),
      [(section: ISection) => section.course, (section: ISection) => _4.get(section, '_section_type.rank', 0)]
    );
  }

  getWaitlistedSections(sections: ISection[]) {
    return _4.filter(sections, (section: ISection) => ScheduledSectionServant.isSectionWaitListed(section));
  }

  getWithdrawnSections(sections: ISection[]) {
    return _4.filter(sections, (section: ISection) => this.ngScheduledSectionServant.isSectionWithdrawn(section));
  }

  getInProgressSections(sections: ISection[]) {
    return _4.filter(sections, (section: ISection) => this.ngScheduledSectionServant.isSectionInProgress(section));
  }
}

angular.module('capability-ng-scheduler').service('ngScheduledSectionFilters', ScheduledSectionFilters);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/course_scheduler/filters/scheduled_section_filters.ts